import { useIntl } from 'react-intl';
import { Stack, Typography } from '@rossum/ui/material';
import { button } from '../../../lib/formaterValues';

type NoFilterResultsOverlayProps = {
  onClearFilters: () => void;
};

export const NoFilterResultsOverlay = ({
  onClearFilters,
}: NoFilterResultsOverlayProps) => {
  const intl = useIntl();

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      spacing={1}
      flex={1}
      p={3}
    >
      <Typography variant="h5" color="text.secondary">
        {intl.formatMessage({
          id: 'features.datasets.noFilterResults.title',
        })}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {intl.formatMessage(
          { id: 'features.datasets.noFilterResults.description' },
          { button: button(onClearFilters) }
        )}
      </Typography>
    </Stack>
  );
};
